module.exports = __webpack_public_path__ + "static/media/live_item_addition551f4ecabecc051bdbaa3a760bffa9dc.webp";